import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { Component, Input, OnChanges, Output } from 'angular-ts-decorators';

import { getColorStyles } from 'src/Foundation/Design/platform/app/utils/get-color-styles';
import { CustomizerFilter, FilterOption, OnFilterChangeHandler } from '../../../models';
import { HeroCustomizerV3FilterRadioComponent } from '../filter-radio/hero-customizer-v3-filter-radio.component';

import template from './hero-customizer-v3-filter-color.component.html';

@Component({
  selector: 'heroCustomizerV3FilterColor',
  template,
})
export class HeroCustomizerV3FilterColorComponent extends HeroCustomizerV3FilterRadioComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public groups?: IProductWithAttributes[];
  @Input() public filter?: CustomizerFilter;

  @Output() public onFilterChange?: OnFilterChangeHandler;

  public activeColorTitle?: string;
  public getColorStyles = getColorStyles;

  public ngOnChanges() {
    this.activeColorTitle = this.selectedColor?.title;
  }

  public onMouseOverColor(colorOption: FilterOption) {
    this.activeColorTitle = colorOption.title;
  }

  public onMouseLeaveColor() {
    this.activeColorTitle = this.selectedColor.title;
  }

  public get selectedColor(): FilterOption | undefined {
    return this.filter?.options.filter((colorOption) => colorOption.checked)[0];
  }
}
